import { Routes } from '@angular/router';

export const ON_TIME_PERFORMANCE_ROUTES: Routes = [
  {
    path: 'booking/:id',
    loadComponent: () =>
      import('./components/otp-review-page/otp-review-page.component').then((m) => m.OtpReviewPageComponent),
  },
];
